module.exports = {
  businessIntelligenceChartTab: 'BI chart',
  businessIntelligenceDashboardTab: 'BI dashboard',
  chartGroupSettingTab: 'Chart group Setting',
  chartConfigurationManagement: 'Tenant BI chart management',
  common: {
    query: 'The query',
    edit: 'The editor',
    save: 'save',
    cancel: 'cancel',
    tenantName: 'The tenant name',
    saveSuccess: 'Save success'
  },
  businessIntelligence: {
    searchKeyword: 'Please enter a keyword search',
    copyChart: 'Copy Charts and Dashboards',
    copyAll: 'Copy to all tenants',
    all: 'all',
    copyIdRemind: 'Please enter the copy object ID',
    copyAllRemind: 'Please select the tenant to copy to',
    chartIdPlaceholder: 'Please enter ID',
    chart: 'chart',
    dashboard: 'dashboard',
    copyChartId: 'Copy Object ID',
    type: 'type',
    copyTo: 'Copy to some tenants',
    openBiChart: 'Open BI chart',
    openTenantBiChart: 'Example Open a tenant BI chart',
    selectTenant: 'Tenants select',
    keywords: 'Please enter key words',
    note: 'note',
    chartNumber: 'Edit the number of tenant charts',
    tenantId: 'The tenant ID',
    initializeChartNum: 'Number of available charts',
    hasBeenUsedChart: 'Number of charts used',
    openingDate: 'Opening date',
    adjustNumber: 'Adjust the quantity',
    expirationTime: 'Expiration time',
    selectTime: 'To choose time',
    adjust1: 'increase',
    adjust2: 'To reduce',
    available: 'Number of available tenant charts',
    hasBeenUsed: 'Number of used tenants in the tenant chart',
    noteInformation: 'Note information',
    saveWarning: 'Please select a Tenant',
    saveSuccess: 'Opened successfully',
    copySuccess: 'Copy succeeded',
    editWarning: 'Please perfect and adjust the quantity',
    editWarningTime: 'Please fill in the expiration time',
    editSuccess: 'Save success',
    adjustQuantity1: 'The number of adjustments cannot be entered negative',
    adjustQuantity2: 'The number of adjustment reduction cannot be greater than the number of user charts'
  },
  businessIntelligenceChart: {
    myChartNum: 'My chart number',
    addChart: 'Adding custom charts',
    queryChart: 'Look up my chart',
    standardChart: 'BI standard chart template library (please select the required chart)',
    queryStandardChart: 'Querying a Chart Template',
    chartTemplate: 'Chart template:',
    classification: 'Classification:',
    chartName: 'Name of the chart',
    chartGrouping: 'Chart Grouping',
    chartId: 'Chart ID Value',
    remark: 'remark',
    editChart: 'Edit User Chart',
    selectAll: 'whole',
    hasChosen: 'Selected',
    notChoose: 'Not selected',
    chartNamePrompt: 'Please enter a chart name',
    chartIdPrompt: 'Please enter chart ID value',
    addSuccess: 'Added Successfully',
    deleteSuccess: 'Delete succeeded',
    warmPrompt: 'Reminder',
    warmPromptStatements: 'Dear tenant, your chart usage limit (${0}) has been reached. If you need to increase the number of charts you can contact WallTech Online Customer Service or run 021-65143931 for consultation.',
    confirmButtonText: 'Got it'
  },
  chartGroupSetting: {
    viewChart: 'view a chart',
    newGrouping: 'New Group',
    delete: 'delete',
    order: 'Serial number',
    groupName: 'Group Name',
    groupNameTips: 'Group name cannot be duplicate',
    remark: 'remarks',
    selectGrouping: 'Select Chart to Group',
    queryChartName: 'Chart Name Query',
    eidtChart: 'Edit Chart',
    currentGrouping: 'Current Group',
    chartDescription: 'Chart Description',
    addGroup: 'Add Group',
    editGroup: 'Edit Group',
    rankRemind: 'Please fill in the group sequence number',
    groupingNameRemind: 'Please fill in the group name',
    chartNameRemind: 'Please fill in the chart name',
    chartGrouping: 'Please select a chart group',
    deleteSuccess: 'Deletion succeeded'
  },
  businessIntelligenceDashboard: {
    addDashboard: 'Add Dashboard',
    delete: 'delete',
    fullScreen: 'Full screen display',
    setFilter: 'Set Filter Items',
    preview: 'preview',
    saveLayout: 'Save Layout',
    dragTips: 'You can adjust the position and size of the chart by dragging.',
    addChart: 'Add Chart',
    dashboardType: 'Instrument cluster type',
    customizeDashboard: 'Customize Dashboard',
    biDashboard: 'BI instrument panel',
    dashboardName: 'Dashboard name',
    dashboardId: 'Dashboard id',
    dashboardNamePlaceholder: 'Please enter the name of the dashboard',
    classification: 'Instrument cluster classification',
    biDashboardId: 'BI instrument cluster ID value',
    biDashboardIdPlaceholder: 'Please enter the instrument cluster ID value',
    Notes: 'Notes',
    setAccessRights: 'Set access rights',
    selectBranch: 'Select Branch',
    selectBranchPlaceholder: 'Please select a company',
    selectDepartment: 'Select Department',
    selectDepartmentPlaceholder: 'Please select a department',
    selectPersonnel: 'Select Personnel',
    selectPersonnelPlaceholder: 'Please select a person',
    setDataPermission: 'Set data permission',
    whole: 'View all data',
    company: 'View Branch Data',
    department: 'View department data',
    personal: 'View personal data only',
    rolePermissions: 'View data according to role permissions',
    chartAddDashboard: 'Select a chart to add to the dashboard',
    queryChartName: 'Chart Name Query',
    add: 'add',
    seePreview: '*Please click the preview to see the effect',
    determine: 'determine',
    setQueryItem: 'Set dashboard query items',
    grouping: 'grouping',
    businessDashboard: 'Business Dashboard',
    financialDashboard: 'Financial Dashboard',
    deleteConfirm: 'Delete this dashboard?',
    tips: 'Tips',
    saveTips: 'Please select a chart to add to the dashboard',
    saveTips1: 'Instrument cluster name cannot be duplicate',
    prompt1: 'Set the access rights of the instrument panel, such as Zhang San, Operation Department of Shanghai Branch.',
    prompt2: 'If only a branch company is set, all personnel under the company name can access it.',
    prompt3: 'The data permission can limit the visible range of the current user data.',
    prompt4: 'For example, if you are only an individual, you can only see your own business data.',
    prompt5: 'Learn more through WallTech Online Customer Service or Operation 021-65143931!',
    prompt6: 'Dear tenant, if you need to learn and use more BI applications, please contact WallTech\'s online customer service or operations at 021-65143931 for consultation.'
  }
}
